module.exports = {"TXTINS_Next":{"id":"TXTINS_Next","defaultMessage":"Επόμενο","track":"Next"}}